// Theme: blueprint
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'blueprint',
  name: 'BLUEPRINT',
  tagline: 'BLUEPRINT',
  description: 'Papel de planta tecnico. Grade branca sobre azul escuro.',
  category: 'system-core',
  tier: 'common',
  basePrice: 250,
  swatches: ['#22344D', '#7DD3FC', '#2A3F60', '#F4F7FB'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '2px',
      '--radius': '4px',
      '--shadow-card': 'none',
      '--shadow-card-active': 'inset 0 0 0 1px color-mix(in srgb, var(--primary) 20%, transparent)'
    },
    shellClasses: 'font-sans theme-blueprint'
  },
  colorVars: {
    '--accent': '#7DD3FC',
    '--accent-foreground': '#22344D',
    '--background': '#22344D',
    '--border': '#4A7AAA',
    '--card': '#2A3F60',
    '--card-border-active': 'rgba(125, 211, 252, 0.05)',
    '--card-completed': '#314A6F',
    '--card-foreground': '#F4F7FB',
    '--card-glow': 'rgba(125, 211, 252, 0.05)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#22344D',
    '--foreground': '#F4F7FB',
    '--hold-fill': '#7DD3FC',
    '--input': '#2A3F60',
    '--modal-bg': '#22344D',
    '--modal-border': '#4A7AAA',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': 'none',
    '--muted': '#4A7AAA',
    '--muted-foreground': '#D4E7F5',
    '--nav-active': '#7DD3FC',
    '--nav-bg': '#22344D',
    '--popover': '#2A3F60',
    '--popover-foreground': '#F4F7FB',
    '--primary': '#7DD3FC',
    '--primary-foreground': '#22344D',
    '--ring': '#7DD3FC',
    '--secondary': '#4A7AAA',
    '--secondary-foreground': '#F4F7FB',
    '--streak': '#7DD3FC',
    '--success': '#22c55e',
    '--success-foreground': '#22344D',
    '--xp': '#7DD3FC',
    '--xp-bg': '#2A3F60'
  },
  resolvedVars: {
    '--accent': '#7DD3FC',
    '--accent-foreground': '#22344D',
    '--accent-foreground-hsl': '215 39% 22%',
    '--accent-foreground-oklch': 'from #22344D l c h',
    '--accent-hsl': '199 95% 74%',
    '--accent-oklch': 'from #7DD3FC l c h',
    '--background': '#22344D',
    '--background-hsl': '215 39% 22%',
    '--background-oklch': 'from #22344D l c h',
    '--border': '#4A7AAA',
    '--border-hsl': '210 39% 48%',
    '--border-oklch': 'from #4A7AAA l c h',
    '--border-w': '2px',
    '--card': '#2A3F60',
    '--card-border-active': 'rgba(125, 211, 252, 0.05)',
    '--card-completed': '#314A6F',
    '--card-completed-hsl': '216 39% 31%',
    '--card-completed-oklch': 'from #314A6F l c h',
    '--card-foreground': '#F4F7FB',
    '--card-foreground-hsl': '214 47% 97%',
    '--card-foreground-oklch': 'from #F4F7FB l c h',
    '--card-glow': 'rgba(125, 211, 252, 0.05)',
    '--card-hsl': '217 39% 27%',
    '--card-oklch': 'from #2A3F60 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#22344D',
    '--destructive-foreground-hsl': '215 39% 22%',
    '--destructive-foreground-oklch': 'from #22344D l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#F4F7FB',
    '--foreground-hsl': '214 47% 97%',
    '--foreground-oklch': 'from #F4F7FB l c h',
    '--hold-fill': '#7DD3FC',
    '--hold-fill-hsl': '199 95% 74%',
    '--hold-fill-oklch': 'from #7DD3FC l c h',
    '--input': '#2A3F60',
    '--input-hsl': '217 39% 27%',
    '--input-oklch': 'from #2A3F60 l c h',
    '--modal-bg': '#22344D',
    '--modal-bg-hsl': '215 39% 22%',
    '--modal-bg-oklch': 'from #22344D l c h',
    '--modal-border': '#4A7AAA',
    '--modal-border-hsl': '210 39% 48%',
    '--modal-border-oklch': 'from #4A7AAA l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': 'none',
    '--muted': '#4A7AAA',
    '--muted-foreground': '#D4E7F5',
    '--muted-foreground-hsl': '205 62% 90%',
    '--muted-foreground-oklch': 'from #D4E7F5 l c h',
    '--muted-hsl': '210 39% 48%',
    '--muted-oklch': 'from #4A7AAA l c h',
    '--nav-active': '#7DD3FC',
    '--nav-active-hsl': '199 95% 74%',
    '--nav-active-oklch': 'from #7DD3FC l c h',
    '--nav-bg': '#22344D',
    '--nav-bg-hsl': '215 39% 22%',
    '--nav-bg-oklch': 'from #22344D l c h',
    '--popover': '#2A3F60',
    '--popover-foreground': '#F4F7FB',
    '--popover-foreground-hsl': '214 47% 97%',
    '--popover-foreground-oklch': 'from #F4F7FB l c h',
    '--popover-hsl': '217 39% 27%',
    '--popover-oklch': 'from #2A3F60 l c h',
    '--primary': '#7DD3FC',
    '--primary-foreground': '#22344D',
    '--primary-foreground-hsl': '215 39% 22%',
    '--primary-foreground-oklch': 'from #22344D l c h',
    '--primary-hsl': '199 95% 74%',
    '--primary-oklch': 'from #7DD3FC l c h',
    '--radius': '4px',
    '--ring': '#7DD3FC',
    '--ring-hsl': '199 95% 74%',
    '--ring-oklch': 'from #7DD3FC l c h',
    '--secondary': '#4A7AAA',
    '--secondary-foreground': '#F4F7FB',
    '--secondary-foreground-hsl': '214 47% 97%',
    '--secondary-foreground-oklch': 'from #F4F7FB l c h',
    '--secondary-hsl': '210 39% 48%',
    '--secondary-oklch': 'from #4A7AAA l c h',
    '--shadow-card': 'none',
    '--shadow-card-active': 'inset 0 0 0 1px color-mix(in srgb, var(--primary) 20%, transparent)',
    '--streak': '#7DD3FC',
    '--streak-hsl': '199 95% 74%',
    '--streak-oklch': 'from #7DD3FC l c h',
    '--success': '#22c55e',
    '--success-foreground': '#22344D',
    '--success-foreground-hsl': '215 39% 22%',
    '--success-foreground-oklch': 'from #22344D l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(199 95% 74% / 0.15)',
    '--xp': '#7DD3FC',
    '--xp-bg': '#2A3F60',
    '--xp-bg-hsl': '217 39% 27%',
    '--xp-bg-oklch': 'from #2A3F60 l c h',
    '--xp-hsl': '199 95% 74%',
    '--xp-oklch': 'from #7DD3FC l c h'
  }
}
